import { render, staticRenderFns } from "./RemoveUserModal.vue?vue&type=template&id=5802e7c4&"
import script from "./RemoveUserModal.vue?vue&type=script&lang=js&"
export * from "./RemoveUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports